import axios from "axios";
import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import Footer from "../Header/Footer";
import Header from "../Header/Header";

const User = () => {

  
  const [profilesData, setProfilesData] = useState([]);
  const [newRequest, setNewRequest] = useState([]);
  const [acceptRequest, setAcceptRequest] = useState([]);
  const [denayRequest, setDenayRequest] = useState([]);
  const [statusupdatedata, setStatusupdatedata] = useState([]);
  const [ageRange, setAgeRange] = useState("");
  const [employedIn, setEmployedIn] = useState("");
  const [jobDescription, setJobDescription] = useState("");
  const [religion, setReligion] = useState("");

  const [cast, setCast] = useState([]);
  const [community, setCommunity] = useState([]);
  const [ageError, setAgeError] = useState("");

  const [selectedCommunity, setSelectedCommunity] = useState("");
  const [selectedCast, setSelectedCast] = useState("");
  const [location, setLocation] = useState("");

  const [filteredProfiles, setFilteredProfiles] = useState([]);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const apikey = process.env.REACT_APP_API_KEY;
  const [presentage,setPresentage]=useState(0)
  const api = process.env.REACT_APP_API;
const getPresentage = async () => {
  const username = localStorage.getItem("username");

  try {
    const res = await axios.get(
      `https://matrimony.bugchat.in/api/getPresentage/${username}`,
      {
        headers: { "x-api-key": apikey },
      }
    );
  setPresentage(res.data.presentage)
    
    // console.log("presentage", res.data.presentage);
    // return res.data.presentage; // if you want to use it later
  } catch (err) {
    console.error("Error fetching presentage:", err);
  }
};

  useEffect(() => {
    const username = localStorage.getItem("username");
    const sex = localStorage.getItem("sex");

    const api = process.env.REACT_APP_API;
    const apikey = process.env.REACT_APP_API_KEY;

    
    const getdata = async () => {
      try {
        // console.log("API URL:", api);

        const response = await axios.post(
          `${api}/api/das_contant`,
          {
            username: username,
            sex: sex,
          },
          {
            headers: {
              "x-api-key": apikey,
              "Content-Type": "application/json",
            },
          }
        );
        setProfilesData(response.data.opposite_data);
        // console.log("Response:", response.data.opposite_data);
      } catch (err) {
        // console.log("API error:", err);
      }
    };

    getdata(); // <-- CALL THE FUNCTION!
    getInterest();
  }, []);
  useEffect(() => {
    const fetchData = async () => {
      try {
        const [casteRes, communityRes] = await Promise.all([
          axios.get("https://matrimony.bugchat.in/api/getcaste", {
            headers: { "x-api-key": apikey },
          }),
          axios.get("https://matrimony.bugchat.in/api/getcommunity", {
            headers: { "x-api-key": apikey },
          }),
        ]);

        setCast(casteRes.data?.caste_list || []);
        setCommunity(communityRes.data?.caste_list || []);
      } catch (error) {
        console.error("Error:", error);
      }
    };

    fetchData();
    getPresentage();
  }, [apikey]);

  const getInterest = async () => {
    const username = localStorage.getItem("username");
    try {
      const response = await axios.post(
        `${api}/api/getinterest`,
        {
          username: username,
        },
        {
          headers: {
            "x-api-key": apikey,
            "Content-Type": "application/json",
          },
        }
      );

      setStatusupdatedata(response.data.user);
      // console.log("lalalala", response.data.user);
      const newInterest = response.data.user.filter(
        (item) => item.status === "Request"
      );
      const accept = response.data.user.filter(
        (item) => item.status === "Accept"
      );
      const denay = response.data.user.filter(
        (item) => item.status === "Denay"
      );

      setNewRequest(newInterest);

      setAcceptRequest(accept);
      setDenayRequest(denay);
    } catch (err) {
      console.log(err);
    }
  };

  const handleFilter = () => {
        if (ageRange && Number(ageRange) < 21) {
      setAgeError("Age must be 21 or above");
      return;
    } else {
      setAgeError("");
    }

    setLoading(true);
    const sex =localStorage.getItem('sex')
    const payload = {
      ageRange,
      employedIn,
      jobDescription,
      religion: religion,
      community: selectedCommunity,
      caste: selectedCast,
      location,
      sex,
    };
    try {

      navigate('/allprofiles',{state:payload})
      // console.log(payload)
    } catch (error) {
      console.log(error);
    }
  };

  const handleViewProfile = async (id) => {
    const api = process.env.REACT_APP_API;
    const apikey = process.env.REACT_APP_API_KEY;
    try {
      const response = await axios.get(`${api}/api/viewprofile/${id}`, {
        headers: {
          "x-api-key": apikey,
          "Content-Type": "application/json",
        },
      });
      if (response.data.status === "Success") {
        navigate("/user/viewprofile", { state: response.data.user });
      }
      // return response.data; // optional, but useful
      // console.log(response.data )
    } catch (error) {
      console.error("Error viewing profile:", error);
      throw error; // optional but recommended
    }
  };

  const handleInterest = async (status, res_username) => {
    try {
      const req_username = localStorage.getItem("username");

      const response = await axios.post(
        `${api}/api/interest_requst`,
        { status, res_username, req_username },
        {
          headers: {
            "x-api-key": apikey,
            "Content-Type": "application/json",
          },
        }
      );

      //   console.log("Success:", response.data);
    } catch (err) {
      console.log("Error:", err);
    }
  };

  const handleEditInterest = async (status, res_username) => {
    try {
      const req_username = localStorage.getItem("username");

      const response = await axios.post(
        `${api}/api/interest_status`,
        { status, res_username, req_username },
        {
          headers: {
            "x-api-key": apikey,
            "Content-Type": "application/json",
          },
        }
      );

      console.log("Success:", response.data);
    } catch (err) {
      console.log("Error:", err);
    }
  };
  return (
    <div>
      {/* PRELOADER */}
      {/* <div id="preloader">
        <div className="plod">
            <span className="lod1"><img src="images/loder/1.png" alt="" loading="lazy"/></span>
            <span className="lod2"><img src="images/loder/2.png" alt="" loading="lazy"/></span>
            <span className="lod3"><img src="images/loder/3.png" alt="" loading="lazy"/></span>
        </div>
    </div> */}
      <div className="pop-bg"></div>
      {/* END PRELOADER */}

      {/* SEARCH */}
      <div className="pop-search">
        <span className="ser-clo">+</span>
        <div className="inn">
          <form>
            <input type="text" placeholder="Search here..." />
          </form>
          <div className="rel-sear">
            <h4>Top searches:</h4>
            <a href="all-profiles.html">Browse all profiles</a>
            <a href="all-profiles.html">Mens profile</a>
            <a href="all-profiles.html">Female profile</a>
            <a href="all-profiles.html">New profiles</a>
          </div>
        </div>
      </div>
      {/* END PRELOADER */}
      <Header />
      {/* LOGIN */}
      <section>
        <div className="db" style={{ padding: "79px 0px 0px 0px" }}>
          <div className="container">
            <div className="row">
              <div className="col-md-4 col-lg-3">
                <div className="db-nav">
                  <div className="db-nav-pro">
                    <img
                      src="images/profiles/12.jpg"
                      className="img-fluid"
                      alt=""
                    />
                  </div>
                  <div className="db-nav-list">
                    <ul>
                      <li>
                        <Link className="act" to={"/user/dashboard"}>
                          <i
                            className="fa fa-tachometer"
                            aria-hidden="true"
                          ></i>
                          Dashboard
                        </Link>
                      </li>
                      <li>
                        <Link to={"/profile"}>
                          <i className="fa fa-male" aria-hidden="true"></i>
                          Profile
                        </Link>
                      </li>
                      <li>
                        <Link to={"/allprofiles"}>
                          <i
                            className="fa fa-handshake-o"
                            aria-hidden="true"
                          ></i>
                          Interests
                        </Link>
                      </li>
                      <li>
                        <Link>
                          <i
                            className="fa fa-commenting-o"
                            aria-hidden="true"
                          ></i>
                          Chat list
                        </Link>
                      </li>
                      <li>
                        <Link to={'/plans'}>
                          <i className="fa fa-money" aria-hidden="true"></i>Plan
                        </Link>
                      </li>
                      <li>
                        <Link>
                          <i className="fa fa-cog" aria-hidden="true"></i>
                          Setting
                        </Link>
                      </li>
                      <li>
                        <Link
                          to={"/login"}
                          onClick={() => {
                            localStorage.clear(); // remove all localStorage keys
                            // navigate("/login"); // redirect after logout (optional)
                          }}
                        >
                          <i className="fa fa-sign-out" aria-hidden="true"></i>{" "}
                          Log out
                        </Link>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
              
              <div className="col-md-8 col-lg-9">
                <div className="row">
                  <div className="col-md-12 col-lg-6 col-xl-4 db-sec-com">
                    <h2 className="db-tit">Profiles status</h2>
                    <div className="db-pro-stat">
                      <h6>Profile completion</h6>
                      <div className="dropdown">
                        <button
                          type="button"
                          className="btn btn-outline-secondary"
                          data-bs-toggle="dropdown"
                        >
                          <i
                            className="fa fa-ellipsis-h"
                            aria-hidden="true"
                          ></i>
                        </button>
                        <ul className="dropdown-menu">
                          <li>
                            <a className="dropdown-item" href="#">
                              Edid profile
                            </a>
                          </li>
                          <li>
                            <a className="dropdown-item" href="#">
                              View profile
                            </a>
                          </li>
                          <li>
                            <a className="dropdown-item" href="#">
                              Profile visibility settings
                            </a>
                          </li>
                        </ul>
                      </div>
                      <div className="db-pro-pgog">
                        <span>
                          
                          <b className="count">{presentage}</b>%
                        </span>
                      </div>
                      <ul className="pro-stat-ic">
                        <li>
                          <span>
                            <i
                              className="fa fa-heart-o like"
                              aria-hidden="true"
                            ></i>
                            <b>12</b>Likes
                          </span>
                        </li>
                        <li>
                          <span>
                            <i
                              className="fa fa-eye view"
                              aria-hidden="true"
                            ></i>
                            <b>12</b>Views
                          </span>
                        </li>
                        <li>
                          <span>
                            <i
                              className="fa fa-handshake-o inte"
                              aria-hidden="true"
                            ></i>
                            <b>12</b>Interests
                          </span>
                        </li>
                        <li>
                          <span>
                            <i
                              className="fa fa-hand-pointer-o clic"
                              aria-hidden="true"
                            ></i>
                            <b>12</b>Clicks
                          </span>
                        </li>
                      </ul>
                    </div>
                  </div>
                  <div className="col-md-12 col-lg-6 col-xl-4 db-sec-com">
                    <h2 className="db-tit">Plan details</h2>
                    <div className="db-pro-stat">
                      <h6 className="tit-top-curv">Standard plan</h6>
                      <div className="dropdown">
                        <button
                          type="button"
                          className="btn btn-outline-secondary"
                          data-bs-toggle="dropdown"
                        >
                          <i
                            className="fa fa-ellipsis-h"
                            aria-hidden="true"
                          ></i>
                        </button>
                        <ul className="dropdown-menu">
                          <li>
                            <a className="dropdown-item" href="#">
                              Edid profile
                            </a>
                          </li>
                          <li>
                            <a className="dropdown-item" href="#">
                              View profile
                            </a>
                          </li>
                          <li>
                            <a className="dropdown-item" href="#">
                              Plan change
                            </a>
                          </li>
                          <li>
                            <a className="dropdown-item" href="#">
                              Download invoice now
                            </a>
                          </li>
                        </ul>
                      </div>
                      <div className="db-plan-card">
                        <img src="images/icon/plan.png" alt="" />
                      </div>
                      <div className="db-plan-detil">
                        <ul>
                          <li>
                            Plan name: <strong>Standard</strong>
                          </li>
                          <li>
                            Validity: <strong>6 Months</strong>
                          </li>
                          <li>
                            Valid till <strong>24 June 2024</strong>
                          </li>
                          <li>
                            <a href="#" className="cta-3">
                              Upgrade now
                            </a>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-12 col-xl-4 db-sec-com">
                    <h2 className="db-tit">Recent chat list</h2>
                    <div className="db-pro-stat">
                      <div className="db-inte-prof-list db-inte-prof-chat">
                        <ul>
                          <li>
                            <div className="db-int-pro-1">
                              {" "}
                              <img src="images/profiles/2.jpg" alt="" />{" "}
                            </div>
                            <div className="db-int-pro-2">
                              <h5>Julia Ann</h5>{" "}
                              <span>Illunois, United States</span>{" "}
                            </div>
                          </li>
                          <li>
                            <div className="db-int-pro-1">
                              {" "}
                              <img src="images/profiles/16.jpg" alt="" />{" "}
                            </div>
                            <div className="db-int-pro-2">
                              <h5>Julia Ann</h5>{" "}
                              <span>Illunois, United States</span>{" "}
                            </div>
                          </li>
                          <li>
                            <div className="db-int-pro-1">
                              {" "}
                              <img src="images/profiles/13.jpg" alt="" />{" "}
                            </div>
                            <div className="db-int-pro-2">
                              <h5>Julia Ann</h5>{" "}
                              <span>Illunois, United States</span>{" "}
                            </div>
                          </li>
                          <li>
                            <div className="db-int-pro-1">
                              {" "}
                              <img src="images/profiles/14.jpg" alt="" />{" "}
                            </div>
                            <div className="db-int-pro-2">
                              <h5>Julia Ann</h5>{" "}
                              <span>Illunois, United States</span>{" "}
                            </div>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* END */}

      <section>
        
        <div className="db" style={{ padding: "0", margin: "0" }}>
          <div className="container">
            <div className="row">
              
              <div
                className="col-md-4 col-lg-3 "
                style={{
                  background: "rgb(255, 255, 255)",
                  borderRadius: "10px",
                  padding: "30px 25px",
                  margin: "60px 0px 70px",
                  border: "1px solid #ebddaa",
                }}
              >
                <div className="col-md-12 fil-mob-view ">
                  <span className="filter-clo">+</span>

                  {/* AGE */}
                  <div className="filt-com lhs-cate">
                    <h4>
                      <i className="fa fa-clock-o"></i>Age
                    </h4>
                    <div className="form-group">
                      <input
                        type="number"
                        placeholder="Enter age above 21"
                        min="21"
                        value={ageRange}
                        onChange={(e) => {
                          const value = e.target.value;
                          setAgeRange(value);
                          if (value && Number(value) < 21) {
                            setAgeError("Age must be 21 or above");
                          } else {
                            setAgeError("");
                          }
                        }}
                      />
                      {ageError && (
                        <p
                          style={{
                            color: "red",
                            fontSize: "13px",
                            marginTop: "5px",
                          }}
                        >
                          {ageError}
                        </p>
                      )}
                    </div>
                  </div>

                  {/* JOB TYPE */}
                  <div className="filt-com lhs-cate">
                    <h4>
                      <i className="fa fa-search"></i> job
                    </h4>
                    <div className="form-group">
                      <select
                        //   className="chosen-select"
                        value={employedIn}
                        onChange={(e) => setEmployedIn(e.target.value)}
                      >
                        <option value="">Select</option>
                        <option value="Business">Business</option>
                        <option value="Defence">Defence</option>
                        <option value="Government/PSC">Government / PSC</option>
                        <option value="MNC">MNC</option>
                        <option value="Private">Private</option>
                        <option value="Self-Employed">Self-Employed</option>
                        <option value="Not Working">Not Working</option>
                      </select>
                    </div>
                  </div>

                  {/* JOB DESCRIPTION */}
                  <div className="filt-com lhs-cate">
                    <h4>
                      <i className="fa fa-search"></i> Job Description{" "}
                    </h4>
                    <div className="form-group">
                      <input
                        type="text"
                        placeholder="Job Description"
                        value={jobDescription}
                        onChange={(e) => setJobDescription(e.target.value)}
                      />
                    </div>
                  </div>

                  {/* RELIGION */}
                  <div className="filt-com lhs-cate">
                    <h4>
                      <i className="fa fa-bell-o"></i>Select Religion
                    </h4>
                    <div className="form-group">
                      <select
                        //   className="chosen-select"
                        value={religion}
                        onChange={(e) => setReligion(e.target.value)}
                      >
                        <option value="">Select</option>
                        <option value="Hindu">Hindu</option>
                        <option value="Muslim">Muslim</option>
                        <option value="Christian">Christian</option>
                        <option value="Sikh">Sikh</option>
                        <option value="Buddhist">Buddhist</option>
                        <option value="Jain">Jain</option>
                        <option value="Other">Other</option>
                      </select>
                    </div>
                  </div>

                  {/* COMMUNITY */}
                  <div className="filt-com lhs-cate">
                    <h4>
                      <i className="fa fa-bell-o"></i>Select Community
                    </h4>
                    <div className="form-group">
                      <select
                        value={selectedCommunity}
                        onChange={(e) => setSelectedCommunity(e.target.value)}
                      >
                        <option value="">Select Community</option>
                        {community.map((item) => (
                          <option key={item.id} value={item.community_name}>
                            {item.community_name}
                          </option>
                        ))}
                      </select>
                    </div>
                  </div>

                  {/* CASTE */}
                  <div className="filt-com lhs-cate">
                    <h4>
                      <i className="fa fa-bell-o"></i>Select cast
                    </h4>
                    <div className="form-group">
                      {cast.length > 0 ? (
                        <select
                          value={selectedCast}
                          onChange={(e) => setSelectedCast(e.target.value)}
                        >
                          <option value="">Select Caste</option>
                          {cast.map((c) => (
                            <option key={c.id} value={c.caste_name}>
                              {c.caste_name}
                            </option>
                          ))}
                        </select>
                      ) : (
                        <p>Loading caste...</p>
                      )}
                    </div>
                  </div>

                  {/* LOCATION */}
                  <div className="filt-com lhs-cate">
                    <h4>
                      <i className="fa fa-map-marker"></i>Location
                    </h4>
                    <div className="form-group">
                      <input
                        type="text"
                        value={location}
                        onChange={(e) => setLocation(e.target.value)}
                      />
                    </div>
                  </div>

                  {/* FILTER BUTTON */}
                  <button
                    onClick={handleFilter}
                    className="btn btn-primary"
                    style={{ width: "100%", marginTop: 15 }}
                  >
                    Apply Filter
                  </button>
                </div>
              </div>
              <div className="col-md-8 col-lg-9">
                <div className="row">
                  <div className="col-md-12 db-sec-com">
                    <h2 className="db-tit">Interest request</h2>
                    <div className="db-pro-stat">
                      <div className="dropdown">
                        <button
                          type="button"
                          className="btn btn-outline-secondary"
                          data-bs-toggle="dropdown"
                        >
                          <i
                            className="fa fa-ellipsis-h"
                            aria-hidden="true"
                          ></i>
                        </button>
                        <ul className="dropdown-menu">
                          <li>
                            <a className="dropdown-item" href="#">
                              Edit profile
                            </a>
                          </li>
                          <li>
                            <a className="dropdown-item" href="#">
                              View profile
                            </a>
                          </li>
                          <li>
                            <a className="dropdown-item" href="#">
                              Plan change
                            </a>
                          </li>
                          <li>
                            <a className="dropdown-item" href="#">
                              Download invoice now
                            </a>
                          </li>
                        </ul>
                      </div>
                      <div className="db-inte-main">
                        <ul className="nav nav-tabs" role="tablist">
                          <li className="nav-item">
                            <a
                              className="nav-link active"
                              data-bs-toggle="tab"
                              href="#home"
                            >
                              New suggestions
                            </a>
                          </li>
                          <li className="nav-item">
                            <a
                              className="nav-link"
                              data-bs-toggle="tab"
                              href="#menu1"
                            >
                              New requests
                            </a>
                          </li>
                          <li className="nav-item">
                            <a
                              className="nav-link"
                              data-bs-toggle="tab"
                              href="#menu2"
                            >
                              Accept request
                            </a>
                          </li>
                          <li className="nav-item">
                            <a
                              className="nav-link"
                              data-bs-toggle="tab"
                              href="#menu3"
                            >
                              Denay request
                            </a>
                          </li>
                        </ul>
                        {/* Tab panes */}
                        {/* Tab panes */}
                        <div className="tab-content">
                          <div id="home" className="container tab-pane active">
                            <br />
                            <div className="db-inte-prof-list">
                              <ul>
                                {profilesData
                                  .filter(
                                    (item) =>
                                      !statusupdatedata.some(
                                        (u) => u.username === item.username
                                      )
                                  )
                                  .slice(0, 10) // <-- limit to 10 items
                                  .map((item, index) => (
                                    <li key={index}>
                                      <div className="db-int-pro-1">
                                        <img
                                          src={
                                            item.user_photo
                                              ? `${process.env.REACT_APP_API}/uploads/${item.user_photo}`
                                              : process.env.PUBLIC_URL +
                                                "/images/user/user.png"
                                          }
                                          alt=""
                                        />
                                      </div>

                                      <div className="db-int-pro-2">
                                        <h5>{item.full_name}</h5>
                                        <ol className="poi">
                                          <li>
                                            Age: <strong>{item.age}</strong>
                                          </li>
                                          {item.education && (
                                            <li>
                                              Education:{" "}
                                              <strong>{item.education}</strong>
                                            </li>
                                          )}
                                          {item.caste_name && (
                                            <li>
                                              Cast:{" "}
                                              <strong>{item.caste_name}</strong>
                                            </li>
                                          )}
                                        </ol>

                                        <a
                                          onClick={() =>
                                            handleViewProfile(item.id)
                                          }
                                          className="cta-5"
                                          style={{ cursor: "pointer" }}
                                        >
                                          View full profile
                                        </a>
                                      </div>

                                      <div className="db-int-pro-3">
                                        <button
                                          type="button"
                                          className="btn btn-success btn-sm"
                                          onClick={() =>
                                            handleInterest(
                                              "Request",
                                              item.username
                                            )
                                          }
                                        >
                                          Send interest
                                        </button>
                                      </div>
                                    </li>
                                  ))}
                              </ul>
                            </div>
                          </div>
                          <div id="menu1" className="container tab-pane fade">
                            <br />
                            <div className="db-inte-prof-list">
                              <ul>
                                {newRequest.map((item, index) => {
                                  return (
                                    <li>
                                      <div className="db-int-pro-1">
                                        {" "}
                                        <img
                                          src={
                                            item.user_photo
                                              ? `${process.env.REACT_APP_API}/uploads/${item.user_photo}`
                                              : process.env.PUBLIC_URL +
                                                "/images/user/user.png"
                                          }
                                          alt=""
                                        />{" "}
                                      </div>
                                      <div className="db-int-pro-2">
                                        <h5>{item.full_name}</h5>
                                        <ol className="poi">
                                          {/* <li>City: <strong>Illunois</strong></li> */}
                                          <li>
                                            Age:{" "}
                                            <strong>{item.age || "N/A"}</strong>
                                          </li>
                                          {/* <li>Height: <strong>5.7</strong></li> */}
                                          {/* <li>Job: <strong>Working</strong></li> */}
                                        </ol>
                                        <ol className="poi poi-date">
                                          {/* <li>Request on: 10:30 AM, 18 August 2024</li>
                            <li>Accept on: 3:000 PM, 21 August 2024</li> */}
                                        </ol>
                                        <a
                                          className="cta-5"
                                          target="_blank"
                                          onClick={() =>
                                            handleViewProfile(item.id)
                                          }
                                          style={{ cursor: "pointer" }}
                                        >
                                          View full profile
                                        </a>
                                      </div>
                                      <div
                                        className="db-int-pro-3"
                                        style={{ display: "flex", gap: "5px" }}
                                      >
                                        <button
                                          type="button"
                                          className="btn btn-success btn-sm"
                                          onClick={() =>
                                            handleEditInterest(
                                              "Accept",
                                              item.username
                                            )
                                          }
                                        >
                                          Accept
                                        </button>
                                        <button
                                          type="button"
                                          className="btn btn-outline-danger btn-sm"
                                          onClick={() =>
                                            handleEditInterest(
                                              "Denay",
                                              item.username
                                            )
                                          }
                                        >
                                          Denay
                                        </button>
                                      </div>
                                    </li>
                                  );
                                })}
                              </ul>
                            </div>
                          </div>
                          <div id="menu2" className="container tab-pane fade">
                            <br />
                            <div className="db-inte-prof-list">
                              <ul>
                                {acceptRequest.map((item, index) => {
                                  return (
                                    <li>
                                      <div className="db-int-pro-1">
                                        {" "}
                                        <img
                                          src={
                                            item.user_photo
                                              ? `${process.env.REACT_APP_API}/uploads/${item.user_photo}`
                                              : process.env.PUBLIC_URL +
                                                "/images/user/user.png"
                                          }
                                          alt=""
                                        />{" "}
                                      </div>
                                      <div className="db-int-pro-2">
                                        <h5>{item.full_name}</h5>
                                        <ol className="poi">
                                          {/* <li>City: <strong>Illunois</strong></li> */}
                                          <li>
                                            Age:{" "}
                                            <strong>{item.age || "N/A"}</strong>
                                          </li>
                                          {/* <li>Height: <strong>5.7</strong></li> */}
                                          {/* <li>Job: <strong>Working</strong></li> */}
                                        </ol>
                                        <ol className="poi poi-date">
                                          {/* <li>Request on: 10:30 AM, 18 August 2024</li>
                            <li>Accept on: 3:000 PM, 21 August 2024</li> */}
                                        </ol>
                                        <a
                                          className="cta-5"
                                          target="_blank"
                                          onClick={() =>
                                            handleViewProfile(item.id)
                                          }
                                          style={{ cursor: "pointer" }}
                                        >
                                          View full profile
                                        </a>
                                      </div>
                                      <div
                                        className="db-int-pro-3"
                                        style={{ display: "flex", gap: "5px" }}
                                      >
                                        <button
                                          type="button"
                                          className="btn btn-success btn-sm"
                                          onClick={() =>
                                            handleEditInterest(
                                              "Accept",
                                              item.username
                                            )
                                          }
                                        >
                                          Accept
                                        </button>
                                        <button
                                          type="button"
                                          className="btn btn-outline-danger btn-sm"
                                          onClick={() =>
                                            handleEditInterest(
                                              "Denay",
                                              item.username
                                            )
                                          }
                                        >
                                          Denay
                                        </button>
                                      </div>
                                    </li>
                                  );
                                })}
                              </ul>
                            </div>
                          </div>
                          <div id="menu3" className="container tab-pane fade">
                            <br />
                            <div className="db-inte-prof-list">
                              <ul>
                                {denayRequest.map((item, index) => {
                                  return (
                                    <li>
                                      <div className="db-int-pro-1">
                                        {" "}
                                        <img
                                          src={
                                            item.user_photo
                                              ? `${process.env.REACT_APP_API}/uploads/${item.user_photo}`
                                              : process.env.PUBLIC_URL +
                                                "/images/user/user.png"
                                          }
                                          alt=""
                                        />{" "}
                                      </div>
                                      <div className="db-int-pro-2">
                                        <h5>{item.full_name}</h5>
                                        <ol className="poi">
                                          {/* <li>City: <strong>Illunois</strong></li> */}
                                          <li>
                                            Age:{" "}
                                            <strong>{item.age || "N/A"}</strong>
                                          </li>
                                          {/* <li>Height: <strong>5.7</strong></li> */}
                                          {/* <li>Job: <strong>Working</strong></li> */}
                                        </ol>
                                        <ol className="poi poi-date">
                                          {/* <li>Request on: 10:30 AM, 18 August 2024</li>
                            <li>Accept on: 3:000 PM, 21 August 2024</li> */}
                                        </ol>
                                        <a
                                          className="cta-5"
                                          target="_blank"
                                          onClick={() =>
                                            handleViewProfile(item.id)
                                          }
                                          style={{ cursor: "pointer" }}
                                        >
                                          View full profile
                                        </a>
                                      </div>
                                      <div
                                        className="db-int-pro-3"
                                        style={{ display: "flex", gap: "5px" }}
                                      ></div>
                                    </li>
                                  );
                                })}
                              </ul>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        
      </section>
      <Footer />
    </div>
  );
};

export default User;
